import { useCallback, useState } from 'react'
import { Stack, MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import { Message } from '@aviation/cabinapp-message-service-sdk';

export interface ICreateDelayCommEventPropertiesProps {
    item: Message;
    validationExecuted: (item : Message, valid : boolean) => void;
}

export function CreateDelayCommEventProperties(props: ICreateDelayCommEventPropertiesProps) {
    const [currentMessage, setCurrentMessage] = useState<Message>(props.item);

    const validate = useCallback(() => {
        const requiredFields : (keyof Message)[] = ['Category'];
        return requiredFields.reduce((a, b) => {
            return a && currentMessage[b] !== undefined;
        }, true);
    }, [currentMessage]);

    const updateField = useCallback((field: string, value: any) => {
        if(field === 'EventDate' && value === 'Invalid Date')
            value = undefined;

        (currentMessage as any)[field] = value;
        const item = {...currentMessage};
        setCurrentMessage(item)

        props.validationExecuted(item, validate());
    }, [currentMessage, props, validate]);

    

    return (
        <Stack direction='column' spacing={2} style={{padding:20}}>
            <FormControl sx={{ minWidth: 200 }} size="small">
                <InputLabel id="category-label">Category</InputLabel>
                <Select
                    labelId="category-label"
                    id="category-select"
                    value={currentMessage.Category}
                    label="Category"
                    error={currentMessage.Category === undefined}
                    onChange={(e) => { updateField('Category', e.target.value); (props.item as any).Category = e.target.value }}
                >
                    <MenuItem key='ETDChange' value='ETDChange'>Changed estimated departure (ETDChange)</MenuItem>
                    <MenuItem key='ETDChange' value='RTDChange'>Rescheduled departure (RTDChange)</MenuItem>
                    <MenuItem key='ReRoute' value='ReRoute'>Destination airport changed (ReRoute)</MenuItem>
                    <MenuItem key='NextInfo' value='NextInfo'>Next Info</MenuItem>
                </Select>
            </FormControl>
            
        </Stack>
    )
}

export default CreateDelayCommEventProperties;